import axios from "axios";

import buildPaginationQueryOpts from "@/shared/sort/sorts";

import { IPermission } from "@/shared/model/permission.model";

const baseApiUrl = 'api/permissions';

export default class PermissionService {
  public find(id: number): Promise<IPermission> {
    return new Promise<IPermission>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IPermission): Promise<IPermission> {
    return new Promise<IPermission>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IPermission): Promise<IPermission> {
    return new Promise<IPermission>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IPermission): Promise<IPermission> {
    return new Promise<IPermission>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // find by user id
  public findByUserId(userId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`api/permissions/user/${userId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  // find by user id list
  public findByUserIdList(userIds: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`api/permissions/users`, { params: { userIds: userIds.reduce((f, s) => `${f},${s}`) } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public mergePermissions(permissionDTOs: any): Promise<any> {
    return axios.post(baseApiUrl + '-merge', permissionDTOs).then(res => {
      return res.data;
    });
  }
}
